interface OptimismIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const OptimismIcon: React.FC<OptimismIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 257 136"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.7002 0C83.3 2.11924e-05 91.9997 1.60047 99.5996 4.90039C107.2 8.00038 113.2 12.8002 117.6 19.2002C122 25.5002 124.2 33.0002 124.2 41.7002C124.2 44.3001 123.9 47.5999 123.3 51.5996C121.4 62.6995 119.2 73.5997 116.5 84.0996C112.1 101.2 104.6 114.1 93.7998 122.6C83.0998 131 68.7001 135.1 50.7002 135.1C35.8002 135.1 23.5996 131.6 14.0996 124.6C4.69994 117.5 4.74487e-05 107.3 0 94.2002C0 91.4002 0.300391 88.0996 0.900391 84.0996C2.50039 75.0997 4.79985 64.2994 7.7998 51.5996C16.2999 17.1998 38.3003 0 73.7002 0ZM210.6 1.90039C224.5 1.90039 235.6 4.8 244 10.5C252.5 16.3 256.8 24.6 256.8 35.5C256.8 38.5999 256.4 41.8999 255.7 45.2998C252.6 59.6998 246.3 70.3002 236.7 77.2002C227.3 84.1002 214.4 87.5 198 87.5H172.7L164.1 128.6C163.8 130 163.2 131.1 162 132C160.9 132.9 159.699 133.3 158.399 133.3H132.899C131.5 133.3 130.5 132.9 129.7 132C129.1 131 128.9 129.9 129.1 128.6L155 6.59961C155.2 5.19988 155.9 4.10009 157.1 3.2002C158.2 2.3002 159.4 1.90039 160.7 1.90039H210.6ZM71.5 26.9004C64.5001 26.9004 58.5 28.9997 53.5 33.0996C48.6001 37.1996 45.1 43.4998 43 52.0996C40.7 60.4996 38.5002 70.7004 36.2002 82.9004C35.7002 85.4002 35.4004 88 35.4004 90.7998C35.3004 102.4 41.4004 108.1 53.4004 108.1C60.4002 108.1 66.3003 106 71.2002 101.9C76.2001 97.8004 79.8004 91.5003 81.9004 82.9004C84.8004 71.1004 87 60.8996 88.5 52.0996C89 49.4997 89.2998 46.7999 89.2998 44C89.2998 32.6 83.4 26.9004 71.5 26.9004ZM177.8 61.5996H199.3C204.6 61.5996 209.1 60.1998 213 57.2998C217 54.3999 219.599 50.3001 220.899 44.9004C221.299 42.8004 221.5 40.8998 221.5 39.2998C221.5 35.6999 220.4 32.9 218.3 31C216.2 29 212.499 28 207.399 28H184.899L177.8 61.5996Z"
        fill={colored ? '#FF0420' : 'currentColor'}
      />
    </svg>
  )
}
